import dynamic from 'next/dynamic';
import { InterfaceClient, InterfaceModes } from '../../stores/InterfaceStore';
import type { WithPartial } from '../../../types';
import type { InterfaceResourceProviderProps } from './types';

const BuilderAndPreviewInterfaceResourceProvider = dynamic(
  () =>
    // eslint-disable-next-line import/no-cycle -- required for circular dependency
    import(
      /* webpackChunkName: "BuilderAndPreviewInterfaceResourceProvider" */
      './builder'
    ),
);

const RunnerInterfaceResourceProvider = dynamic(
  () =>
    import(
      /* webpackChunkName: "RunnerInterfaceResourceProvider" */
      './runner'
    ),
);

export function InterfaceResourceProvider(
  props: WithPartial<InterfaceResourceProviderProps, 'mode' | 'deviceDetails' | 'client'> & {
    disableInteractiveMode?: boolean;
    disableDevTools?: boolean;
  },
) {
  const {
    mode = InterfaceModes.RUNNER,
    client = mode === InterfaceModes.RUNNER
      ? InterfaceClient.UA_MATRIX
      : InterfaceClient.UA_PLATFORM,
  } = props;

  return mode === InterfaceModes.RUNNER ? (
    <RunnerInterfaceResourceProvider {...props} client={client} mode={mode} />
  ) : (
    <BuilderAndPreviewInterfaceResourceProvider {...props} client={client} mode={mode} />
  );
}

export default InterfaceResourceProvider;
